import c from '@/styles/TextSubtitle';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';

export interface TextSubtitleProps extends ComponentProps<'h3'> {
  variant?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'primary'>;
}

const TextSubtitleComponent: Component<TextSubtitleProps> = ({
  className,
  variant,
  size,
  colors,
  children,
  ...props
}) => {
  const getPropStyles = getPropStylesFactory(c);

  const variantClassName = getPropStyles('variant', variant, 'default');
  const sizeClassName = getPropStyles('size', size, 'default');
  const colorsClassName = getPropStyles('colors', colors, 'primary');

  const componentClassName = cn(variantClassName, sizeClassName, colorsClassName, className);
  return (
    <h3 className={componentClassName} {...props}>
      {children}
    </h3>
  );
};

export const TextSubtitle = TextSubtitleComponent;
